/**
 * Глобальный хоткей «найти на доске»: macOS/iOS — ⌘F, Windows/Linux — Ctrl+F.
 * Используем {@link KeyboardEvent.code} === KeyF (физическая клавиша), а не {@link KeyboardEvent.key},
 * чтобы сочетание работало при любой раскладке (в т.ч. русской).
 */

export function isAppleLikeOs(): boolean {
	if (typeof navigator === 'undefined') return false;
	const p = navigator.platform ?? '';
	if (/Mac|iPhone|iPad|iPod/i.test(p)) return true;
	return /Mac OS/i.test(navigator.userAgent ?? '');
}

/** Фокус в поле ввода — не перехватываем, чтобы не ломать ввод и поиск страницы в браузере. */
export function isTypingInFormField(target: EventTarget | null): boolean {
	if (!(target instanceof Element)) return false;
	const host = target.closest('input, textarea, select, [contenteditable="true"]');
	if (!host) return false;
	if (host instanceof HTMLInputElement) {
		const t = host.type?.toLowerCase() ?? '';
		if (
			t === 'checkbox' ||
			t === 'radio' ||
			t === 'button' ||
			t === 'submit' ||
			t === 'reset' ||
			t === 'file' ||
			t === 'hidden'
		) {
			return false;
		}
	}
	return true;
}

/** Обычное Cmd+F / Ctrl+F без Shift/Alt (без конфликта с «найти следующим» и т.п.). */
export function isBoardFindShortcut(e: KeyboardEvent): boolean {
	if (e.code !== 'KeyF') return false;
	if (e.repeat) return false;
	if (e.altKey || e.shiftKey) return false;
	if (isAppleLikeOs()) {
		return e.metaKey && !e.ctrlKey;
	}
	return e.ctrlKey && !e.metaKey;
}

/** Подпись для подсказок в UI (одна платформа за раз). */
export function boardFindShortcutLabel(): string {
	return isAppleLikeOs() ? '⌘F' : 'Ctrl+F';
}
